import axios from 'axios'
import { The, createJsonData, createFormData } from 'helpers/generalHelpers'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'

// // #region FIELD

const workspace = getCurrentWorkspace()

export const field = {
  create: (formSlug, fieldData) =>
    The(
      axios.post(
        `${APIURL}/v4/fields/`,
        createFormData({
          form: formSlug,
          ...fieldData,
        }),
        config({ workspace })
      )
    ),

  getOne: (fieldSlug) =>
    The(axios.get(`${APIURL}/v4/fields/${fieldSlug}/`, config({ workspace }))),

  copy: (fieldSlug) =>
    The(
      axios.post(
        `${APIURL}/v4/fields/duplicate/`,
        createFormData({ copied_field: fieldSlug }),
        config({ workspace })
      )
    ),

  delete: (fieldSlug, deleteData) =>
    The(
      axios.delete(
        `${APIURL}/v4/fields/${fieldSlug}/`,
        config({
          data: createJsonData(deleteData),
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),

  edit: (fieldSlug, formData) =>
    axios.patch(
      `${APIURL}/v4/fields/${fieldSlug}/`,
      formData,
      config({ contentType: HTTP.ContentTypes.JSON, workspace })
    ),

  getChoices: (fieldSlug, params) =>
    axios.get(
      `${APIURL}/v4/fields/${fieldSlug}/choices/`,
      config({ params, workspace })
    ),
}

// #endregion FIELD
